module.exports = __webpack_public_path__ + "static/media/fe_video.1ce922e6.mov";